import React from 'react';

export const PopupConfirm = ({ isOpen, id, title, content, onConfirm, onCancel }) => {
  const handleClose = () => {
    if (typeof onCancel === 'function') {
      onCancel();
    }
  };

  const handleConfirm = () => {
    if (typeof onConfirm === 'function') {
      onConfirm();
    }
  };

  if (!isOpen) {
    return <></>;
  }

  return (
    <React.Fragment>
      <div className='modal fade' id={id} tabIndex='-1' role='dialog' aria-labelledby={id} aria-hidden='true'>
        <div className='modal-dialog' role='document'>
          <div className='modal-content'>
            <div className='modal-header'>
              <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body pt-0 text-center'>
              <div className='mb-3 fs-m txtBlack'>{title}</div>
              {content}
            </div>
            <div className='modal-footer'>
              <div className='row w-100 justify-content-center'>
                <a href='javascript:;' className='btn btn-outline-secondary w-100 ml-3' data-dismiss='modal' onClick={handleClose}>Đóng</a>
              </div>
              <div className='row w-100 justify-content-center'>
                <a href='javascript:;' className='btn btn-outline-primary w-100 mr-3' onClick={handleConfirm} data-dismiss='modal'>Đồng ý</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
